import styled from "@emotion/styled";
import { CheckboxProps, Checkbox } from "@mui/material";
import { Colors } from "../utils/colors";

const CustomCheckboxUnchecked = styled("span")((props) => ({
  borderRadius: 4,
  width: 18,
  height: 18,
  backgroundColor: Colors.GRAY6,
  boxShadow: "inset 0 0 0 1.5px #929292, inset 0 -1.5px 0 #929292",
  "input:hover ~ &": {
    boxShadow: `inset 0 0 0 1.5px ${
      props.color !== "" ? props.color : "#007AFF"
    }, inset 0 -1.5px 0 ${props.color !== "" ? props.color : "#007AFF"}`,
  },
  "input:disabled ~ &": {
    boxShadow: "none",
    background: "#F4F5F6",
  },
}));

const CustomCheckboxChecked = styled(CustomCheckboxUnchecked)((props) => ({
  backgroundColor: props.color !== "" ? props.color : Colors.BLUE5,
  boxShadow: `inset 0 0 0 1px ${
    props.color !== "" ? props.color : "#007AFF"
  }, inset 0 -1px 0 ${props.color !== "" ? props.color : "#007AFF"}`,
  "&:before": {
    display: "block",
    width: 18,
    height: 18,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  "input:hover ~ &": {
    backgroundColor: props.color !== "" ? props.color : "#106ba3",
  },
}));

interface CustomCheckboxProps extends CheckboxProps {
  // Add your custom props here
  altColor?: string;
}

const CustomCheckbox = (props: CustomCheckboxProps) => {
  const { altColor } = props;
  return (
    <Checkbox
      sx={{
        "&:hover": { bgcolor: "transparent" },
      }}
      disableRipple
      color="default"
      checkedIcon={<CustomCheckboxChecked color={altColor ?? ""} />}
      icon={<CustomCheckboxUnchecked color={altColor ?? ""} />}
      inputProps={{ "aria-label": "Checkbox demo" }}
      {...props}
    />
  );
};

export default CustomCheckbox;
